<template>
  <Listbox
    v-slot="{ open }"
    as="div"
    by="key"
    class="relative w-full bg-grey-100"
    :model-value="modelValue"
    @update:model-value="(value) => emit('update:modelValue', value)"
  >
    <!-- Bridge slot 'open' to script for watching -->
    <template v-if="open !== openState">
      <span v-if="updateOpen(open)" style="display:none" />
    </template>
    <!-- HEADER -->
    <ListboxButton
      :id="`headlessui-listbox-button-${handle}`"
      v-slot="{ value }"
      :class="open ? 'border-transparent' : error ? 'border-error' : 'border-black'"
      class="w-full border-b transition-colors"
    >
      <div class="flex w-full items-center justify-between gap-[0.25em] p-4">
        <span class="truncate typo-subtitle" :class="{ 'text-grey-300': !value.key }">
          {{ value.value || placeholder || $t('forms.please_chose') }}
        </span>
        <IconChevron
          v-if="!value.key"
          class="ml-1 size-7 shrink-0 rotate-0 transition-all md:size-[1.5em] ui-open:rotate-180"
        />
        <IconClose
          v-else
          class="size-6 shrink-0 md:size-[1em]"
          @click="emit('update:modelValue', {})"
        />
      </div>
    </ListboxButton>

    <!-- OPTIONS -->
    <Transition :open="open" name="fade">
      <ListboxOptions class="absolute top-full z-20 w-full max-w-full overflow-hidden rounded bg-grey-100">
        <ListboxOption
          v-for="option in options"
          :key="option.key"
          :value="option"
          class="
            max-w-full cursor-pointer truncate p-3 transition-colors
            hover:bg-grey-300
            ui-selected:bg-primary-900 ui-selected:text-white
          "
        >
          {{ shouldTranslate ? $t(`forms.${option.key}`) : (option.value || option) }}
        </ListboxOption>
      </ListboxOptions>
    </Transition>
  </Listbox>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'

import { ref } from 'vue'

defineProps({
  handle: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  error: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue', 'update:open'])

const openState = ref(false)
const shouldTranslate = inject('shouldTranslate', false)

function updateOpen(newOpen) {
  if (openState.value !== newOpen) {
    openState.value = newOpen
    emit('update:open', newOpen)
  }
  return true
}
</script>
